import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AUTH_API_BASE_URL } from '../core.module';
import { ApiResponse, ApiResponseCode } from '../models/ApiResponse';
import { isApiResponse } from '../utilities';

@Injectable({
  providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
  constructor(@Inject(AUTH_API_BASE_URL) private authApiBaseUrl: string) {}

  intercept<T>(request: HttpRequest<ApiResponse<T>>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modified = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Accept: 'application/json, application/pdf, text/plain, application/octet-stream, */*',
      },
    });

    return next.handle(modified).pipe(
      mergeMap((response: HttpEvent<ApiResponse<T>>) => {
        if (!(response instanceof HttpResponse)) {
          return of(response);
        }

        if (!isApiResponse(response.body)) {
          return of(response);
        }

        if (response.body.code == ApiResponseCode.Success) {
          return of(response);
        }

        if (
          response.body.code == ApiResponseCode.Unauthorized ||
          response.body.code == ApiResponseCode.KratosCookieMissing ||
          response.body.code == ApiResponseCode.KratosUnauthorized
        ) {
          const authUrl = new URL(this.authApiBaseUrl);
          const return_to = authUrl + '?return_to=' + window.location.href;
          authUrl.searchParams.append('return_to', return_to);

          window.location.href = authUrl.toString();
        }
        return throwError(response);
      }),
    );
  }
}
